//==============================================
// Block: Page Hero
//==============================================

var initBlockHeroPage = function( $block ) {

    let blockInit = gsap.timeline(),

    blockImageOverlay = $block.find('.block-image-overlay'),
    blockBox = $block.find('.block-image-box'),
    blockImageBar = $block.find('.block-image-bar');

    
    blockInit.to(blockImageOverlay, {
        duration: 1,
        ease: "power1.out",
        delay: 0.5,
        width: 0,
    })
    .to(blockBox, {
        duration: 0.5,
        ease: "power1.out",
        right: '-6%',
        top: '-5.5%',
    })
    .to(blockImageBar, {
        duration: 0.5,
        ease: "power1.out",
        width: '40%',
    });

};


// Initialize each block on page load (front end).
$(document).ready(function(){
    $('.block-page-hero').each(function(){
        initBlockHeroPage( $(this) );
    });
});

if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=block-hero-page', initBlockHeroPage );
}